import { useMemo } from "react";

import { queryOptions, useQuery } from "@tanstack/react-query";

import { QueryOptions } from "./types";
import { ClientSearchInput } from "@typeDefinitions/types";
import { parseNumber, parseString } from "@utils/filters";
import { getClientsAPI } from "@client/clients/getClientsAPI";

import { clientKeys } from "./clientKeys";

export const clientsQuery = (inputs?: ClientSearchInput) => {
  const params = parseClinicClientsSearch(inputs);
  return queryOptions({
    queryKey: clientKeys.list(params.toString()),
    queryFn: () => getClientsAPI(params),
  });
};

export const useFetchClientsQuery = (
  inputs?: ClientSearchInput,
  options?: QueryOptions,
) => {
  const query = useMemo(() => clientsQuery(inputs), [inputs]);

  const { data, ...rest } = useQuery({ ...query, ...options });

  return {
    clients: data?.data,
    ...rest,
  };
};

const parseClinicClientsSearch = (filters?: ClientSearchInput) => {
  const search = new URLSearchParams();
  parseNumber(filters?.active, "active", search);
  parseNumber(filters?.mobileAppActive, "mobile-app-active", search);

  if (filters?.search?.trim()) {
    parseString(filters?.search, "search", search);
  }

  return search;
};
